module.exports = __webpack_public_path__ + "assets/img/busy_6.bd0cd8d1.png";